import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { Schema } from 'features/globalSetup/pages/Defaults/RichPlacements/Sections/KWordsSection/schema'
import type { UpdateRichPlacementKWordsMutationVariables } from 'gql/graphql'

type From = Schema
type To = Pick<UpdateRichPlacementKWordsMutationVariables['input'], 'kwordsSiteId'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ kwordsSiteId }: From): To => ({
      kwordsSiteId,
    }),
  )
